export default __webpack_public_path__ + "static/media/zhuanli2.b5371cc0.jpg";